const DEV = "Software Development";
const IT = "IT Support Documentation";
const TECH = "Technical Documentation";
const PROJ = "Project Proposal";
const FIN = "Financial Proposal";

export const KB_TEMPLATES = [
  {
    id: "techdoc", name: "Technical documentation", group: TECH, tags: "technical, architecture",
    content: `SYSTEM / PROJECT:
VERSION:              OWNER:              LAST UPDATED:

1. OVERVIEW
What it does and who uses it.

2. ARCHITECTURE
Diagram reference and short description of each part.

3. COMPONENTS
- Name | Purpose | Technology | Hosted at

4. CONFIGURATION
Key settings (no passwords - reference the vault).

5. DATA AND BACKUP
What is stored, where, backup schedule, restore steps.

6. SECURITY
Login method, roles, encryption.

7. OPERATIONS
Deploy, monitor, common maintenance tasks.

8. CONTACTS AND CHANGE LOG
- Date | Change | By`,
  },
  {
    id: "projprop", name: "Project proposal", group: PROJ, tags: "proposal, project",
    content: `PROJECT TITLE:
CLIENT:                 PROPOSAL NO:              DATE:
PREPARED BY:            VALID UNTIL:

1. EXECUTIVE SUMMARY

2. BACKGROUND AND PROBLEM

3. OBJECTIVES
-

4. SCOPE OF WORK
In scope:
1.
Out of scope:
-

5. APPROACH AND METHODOLOGY
Phase 1 - Assessment
Phase 2 - Design
Phase 3 - Implementation
Phase 4 - Testing and handover

6. TIMELINE
- Phase | Start | End

7. PROJECT TEAM
- Role | Name | Responsibility

8. ASSUMPTIONS AND CLIENT RESPONSIBILITIES

9. RISKS AND MITIGATION
- Risk | Mitigation

10. WARRANTY AND SUPPORT

11. ACCEPTANCE
Client signature ______    KINOS signature ______`,
  },
  {
    id: "finprop", name: "Financial proposal", group: FIN, tags: "financial, pricing",
    content: `FINANCIAL PROPOSAL NO:          LINKED PROJECT PROPOSAL:
CLIENT:                          DATE:              VALID FOR:     days
CURRENCY:                        TAX: included / excluded

No | Description | Qty | Unit | Unit price | Total
1  |             |     |      |            |
2  |             |     |      |            |
3  |             |     |      |            |

SUBTOTAL:
DISCOUNT:
TAX:
GRAND TOTAL:

PAYMENT TERMS
-

DELIVERY TIME

WARRANTY AND SUPPORT

EXCLUSIONS
-

BANK DETAILS

AUTHORISED BY (name, title, signature):`,
  },
  {
    id: "howto", name: "How-to guide", group: IT, tags: "how-to, guide",
    content: `PURPOSE
What this guide helps the reader do.

WHO IS THIS FOR
End users / IT staff / developers.

BEFORE YOU START
- Requirement 1
- Requirement 2

STEPS
1.
2.
3.

RESULT
What the reader should see when finished.

NEED HELP?
Open a ticket in the [category] category.`,
  },
  {
    id: "troubleshoot", name: "Troubleshooting guide", group: IT, tags: "troubleshooting",
    content: `SYMPTOMS
What the user sees (error message, behaviour).

LIKELY CAUSES
- Cause 1
- Cause 2

QUICK FIXES (user can try)
1.
2.

SUPPORT STEPS (IT staff)
1.
2.

ESCALATE WHEN
- Condition, and to whom.

RELATED ARTICLES
-`,
  },
  {
    id: "sop", name: "Standard operating procedure (SOP)", group: IT, tags: "sop, procedure",
    content: `SOP TITLE:
VERSION:            OWNER:            LAST REVIEWED:

SCOPE
Which team and situation this covers.

RESPONSIBILITIES
- Role: responsibility

PROCEDURE
1.
2.
3.

QUALITY CHECKS
[ ]
[ ]

RECORDS
Where results are logged (ticket, asset register, etc.).`,
  },
  {
    id: "incident", name: "Incident report", group: IT, tags: "incident, post-mortem",
    content: `INCIDENT:                     TICKET:
DATE / TIME STARTED:          RESOLVED:
SEVERITY: Critical / High / Medium / Low
INCIDENT OWNER:

SUMMARY
What happened in two or three sentences.

IMPACT
Users, services and business affected.

TIMELINE
- HH:MM  event
- HH:MM  event

ROOT CAUSE

RESOLUTION

WHAT WENT WELL / WHAT TO IMPROVE

FOLLOW-UP ACTIONS
- Action | Owner | Due date`,
  },
  {
    id: "handover", name: "Asset / hardware handover", group: IT, tags: "asset, handover",
    content: `EMPLOYEE:            DEPARTMENT:            DATE:

ITEMS
[ ] Device - asset tag ______ serial ______
[ ] Accessories:

CONDITION NOTES

CONFIRMED
[ ] User can log in
[ ] User has read the IT acceptable use policy

Signatures: Employee ______  IT staff ______`,
  },
  {
    id: "release", name: "Release notes", group: DEV, tags: "release notes, changelog",
    content: `PRODUCT:              VERSION:              RELEASE DATE:

HIGHLIGHTS
- Main change users will notice

NEW FEATURES
-

IMPROVEMENTS
-

BUG FIXES
- [ticket number] description

KNOWN ISSUES
-

ACTION NEEDED FROM USERS
None / describe.`,
  },
  {
    id: "api", name: "API endpoint documentation", group: DEV, tags: "api, documentation",
    content: `ENDPOINT: METHOD /api/path
DESCRIPTION:
AUTHENTICATION: required role / token

REQUEST
Parameters:
- name (type, required) - description
Body example:
{
  "field": "value"
}

RESPONSE 200
{
  "id": "..."
}

ERRORS
- 400 invalid input
- 401 not logged in
- 403 no permission
- 404 not found

NOTES
Rate limits, pagination, side effects.`,
  },
  {
    id: "srs", name: "Software requirements spec", group: DEV, tags: "requirements, spec",
    content: `PROJECT:               CLIENT / OWNER:               VERSION:

1. GOAL
The problem this software solves.

2. USERS AND ROLES
- Role: what they need to do

3. FUNCTIONAL REQUIREMENTS
FR-1:
FR-2:

4. NON-FUNCTIONAL REQUIREMENTS
Performance, security, availability, languages (English / Tetum).

5. OUT OF SCOPE
-

6. ACCEPTANCE CRITERIA
[ ]
[ ]

7. TIMELINE AND MILESTONES
-`,
  },
  {
    id: "bug", name: "Bug report", group: DEV, tags: "bug, qa",
    content: `TITLE:
APPLICATION / VERSION / ENVIRONMENT:

STEPS TO REPRODUCE
1.
2.
3.

EXPECTED RESULT

ACTUAL RESULT

FREQUENCY: always / sometimes / once
DEVICE AND BROWSER:
IMPACT: blocks work / workaround exists / cosmetic
ATTACHMENTS: screenshots, logs`,
  },
  {
    id: "runbook", name: "Deployment runbook", group: DEV, tags: "deployment, runbook",
    content: `APPLICATION:            ENVIRONMENT:            OWNER:

PRE-CHECKS
[ ] Tests passing
[ ] Backup taken
[ ] Users notified of maintenance window

DEPLOY STEPS
1.
2.

VERIFY
- Smoke test steps

ROLLBACK PLAN
1.

CONTACTS
- On-call engineer:`,
  },
  {
    id: "setup", name: "Developer setup guide", group: DEV, tags: "setup, onboarding",
    content: `PROJECT:
REPOSITORY: [repository URL]

PREREQUISITES
- Tools and versions

SETUP
1. Clone the repository
2. Copy .env.example to .env (values from the team vault)
3. Install dependencies
4. Start the app

VERIFY
- App loads, tests pass

COMMON PROBLEMS
- Problem: fix`,
  },
];
